import {
  Box,
  Button,
  makeStyles,
  Paper,
  Slide,
  Typography,
} from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { Datatable } from '../../../components';
import { useYodlee } from '../../../modules/Yodlee/Yodlee';
import { AppContext } from '../../../modules/AppContext';
import { LoaderSubmitButton } from '../../../components/LoaderSubmitButton';
import { SearchOutlined } from '@material-ui/icons';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    width: '100%',
    padding: '20px',
    margin: '0',
  },
  content: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
  },
  mainContent: {
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(2, 0),
  },
}));

export const BatchYodleeRelink = () => {
  const classes = useStyles();
  const yodlee = useYodlee();
  const { showToast } = useContext(AppContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [triggeringRelinks, setTriggeringRelinks] = useState(false);

  const tableConfig = [
    {
      sortable: true,
      heading: 'Account ID',
      key: 'accountId',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Participant ID',
      key: 'participantId',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Email',
      key: 'participantEmailAddress',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Advisor',
      key: 'advisor',
      formatter: (val) => val,
    },
    {
      sortable: true,
      heading: 'Last Update',
      key: 'lastYodleeUpdateTimestamp',
      formatter: (val) => (!!val ? moment(val).format('MM/DD/YYYY') : ''),
    },
  ];

  return (
    <div className={classes.wrapper}>
      <Paper elevation={1} className={classes.content}>
        <Box display="flex" justifyContent="space-between">
          <Typography variant="h6" className={classes.title}>
            Yodlee Batch Request Relink
          </Typography>
          <Box display="flex" gridGap="1rem">
            <LoaderSubmitButton
              icon={<SearchOutlined />}
              disabled={loading || fetched}
              loading={loading}
              onClick={async () => {
                setLoading(true);
                const response = await yodlee.getBatchRelink();
                if (response.ok) {
                  showToast({
                    message: 'Successfully fetched Yodlee links needing relink',
                    type: 'success',
                  });
                  setData(await response.json());
                  setFetched(true);
                } else {
                  showToast({
                    message: 'Failed to fetch links',
                    type: 'error',
                  });
                }
                setLoading(false);
              }}
            >
              Preview
            </LoaderSubmitButton>
            <LoaderSubmitButton
              disabled={data.length === 0}
              loading={triggeringRelinks}
              onClick={async () => {
                showToast({
                  message:
                    'Starting batch relink, this could take up to a few minutes.',
                  type: 'info',
                });
                setTriggeringRelinks(true);
                const response = await yodlee.triggerBatchRelink();
                if (response.ok) {
                  showToast({
                    message: 'Successfully triggered batch relink',
                    type: 'success',
                  });
                  setData([]);
                  setFetched(false);
                } else {
                  showToast({
                    message: 'Failed to trigger batch relink',
                    type: 'error',
                  });
                }
                setTriggeringRelinks(false);
              }}
            >
              Send Relinks
            </LoaderSubmitButton>
          </Box>
        </Box>
      </Paper>
      <section className={classes.mainContent}>
        {data.length > 0 && (
          <Datatable loading={loading} data={data} tableConfig={tableConfig} />
        )}
      </section>
    </div>
  );
};
